<p-drawer
           [(visible)]="displaySidenavMenu"
           position="right"
           (onShow)="focusMenuFilter()"
           [closeOnEscape]="true">
    <ng-template pTemplate="header">
        <app-input
            #searchInput
            placeholder="Cerca nel menu"
            icon="pi pi-search"
            [showLength]="false"
            [model]="menuFilter"
            (modelChange)="populateSidebarMenu($event)"
        ></app-input>
    </ng-template>

    <ng-template pTemplate="content">
        <div>
            <p-menu [model]="mainMenu" styleClass="menu"></p-menu>
        </div>

        <app-switch-user></app-switch-user>

        <div class="theme-chooser">
            <p-menu [model]="bottomMenu" styleClass="menu"></p-menu>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <app-version></app-version>
    </ng-template>
</p-drawer>

<div class="container">
    <p-toolbar class="toolbar p-2">
        <ng-template #start>
            <app-toolbar></app-toolbar>
        </ng-template>

        <ng-template #end>

            <div class="mr-3 inline-block">
                <app-fast-dial-numbers></app-fast-dial-numbers>
            </div>

            @if (mftWebOldPage) {
                <div class="inline-block">
                    <button pButton pRipple (click)="openMftWebOldPage()" class="text-center p-button-text mr-3"
                            icon="fas fa-history"
                            pTooltip="Vai alla vecchia versione" tooltipPosition="left">
                    </button>
                </div>
            }

            <div class="inline-block">
                <app-notifications-button *appAcl="AclPermission.SignalRNotificationsEnabled"></app-notifications-button>
            </div>

            <p-button (click)="displaySidenavMenu = true"
                      icon="pi pi-bars"
                      label="Menu"
                      class="menu-button p-button-outlined"></p-button>
        </ng-template>
    </p-toolbar>

    <div class="content grid-nogutter">
        <router-outlet></router-outlet>
    </div>
</div>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [style]="{width: '80ch'}"></p-confirmDialog>

